var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBstock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 60,
    viewBox: "0 0 160 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_3988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2537 35.4316C28.9295 35.4316 29.4571 35.2868 29.8362 34.9971C30.2154 34.7074 30.3967 34.305 30.3967 33.774C30.3967 32.744 29.6878 32.229 28.2372 32.229H24.7259V35.4477H28.2372L28.2537 35.4316ZM18 20.0944H35.6224V25.1961H24.7259V27.5135H29.5725C32.0617 27.5135 33.9575 28.0285 35.2763 29.0746C36.5951 30.1207 37.2709 31.6174 37.2709 33.5808C37.2709 35.5443 36.5126 37.2341 34.996 38.3928C33.4794 39.5516 31.3858 40.147 28.6987 40.147H18V20.0944Z",
    fill: "#454EA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8929 27.5135H40.1724V32.3899H48.8929V27.5135Z",
    fill: "#454EA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4155 39.278C55.6846 38.3928 54.3328 37.1536 53.3602 35.5604C52.3876 33.9671 51.8931 32.1646 51.8931 30.1368C51.8931 28.109 52.3876 26.3065 53.3602 24.7132C54.3328 23.12 55.6846 21.8808 57.4155 20.9956C59.1465 20.1105 61.0752 19.6598 63.2182 19.6598C65.1964 19.6598 66.9603 20.0139 68.5099 20.6898C70.0595 21.3819 71.3289 22.3797 72.3344 23.6672L67.9989 27.4813C66.746 25.9203 65.2624 25.1317 63.5479 25.1317C62.1138 25.1317 60.9598 25.5823 60.0861 26.4996C59.2124 27.4009 58.7838 28.624 58.7838 30.1529C58.7838 31.6818 59.2124 32.9049 60.0861 33.8061C60.9598 34.7074 62.1138 35.1741 63.5479 35.1741C65.2459 35.1741 66.7295 34.3855 67.9989 32.8244L72.3344 36.6386C71.3289 37.9422 70.043 38.9239 68.5099 39.6159C66.9603 40.308 65.1964 40.6459 63.2182 40.6459C61.0587 40.6459 59.13 40.2114 57.4155 39.3102V39.278Z",
    fill: "#454EA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3142 25.3409H86.3466V40.147H79.6208V25.3409H73.6697V20.0944H92.3142V25.3409Z",
    fill: "#454EA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.993 33.5004L127.444 35.1902V40.147H120.718V20.0944H127.444V27.3687L134.137 20.0944H141.588L133.461 28.9137L142 40.147H134.071L128.977 33.5004H128.993Z",
    fill: "#454EA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.947 40.9839C112.166 40.9839 117.207 36.0626 117.207 29.992C117.207 23.9213 112.166 19 105.947 19C99.7292 19 94.6882 23.9213 94.6882 29.992C94.6882 36.0626 99.7292 40.9839 105.947 40.9839Z",
    fill: "#454EA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.595 35.0775L102.057 35.4316L110.448 25.2443L109.986 24.8903L109.525 24.5362L101.134 34.7235L101.595 35.0775ZM110.448 25.2604C110.646 25.019 110.613 24.665 110.365 24.4557C110.118 24.2626 109.756 24.2948 109.541 24.5362L110.003 24.8903L110.464 25.2443L110.448 25.2604ZM101.134 34.7235C100.936 34.9649 100.969 35.3189 101.216 35.5282C101.464 35.7213 101.826 35.6891 102.041 35.4477L101.579 35.0936L101.117 34.7396L101.134 34.7235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.991 28.3182C102.865 28.3182 103.574 27.6049 103.574 26.7249C103.574 25.845 102.865 25.1317 101.991 25.1317C101.117 25.1317 100.408 25.845 100.408 26.7249C100.408 27.6049 101.117 28.3182 101.991 28.3182Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.003 35.1097C110.877 35.1097 111.585 34.3964 111.585 33.5165C111.585 32.6365 110.877 31.9232 110.003 31.9232C109.129 31.9232 108.42 32.6365 108.42 33.5165C108.42 34.3964 109.129 35.1097 110.003 35.1097Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_3988"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 22,
    fill: "white",
    transform: "translate(18 19)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBstock);
export default __webpack_public_path__ + "static/media/bstock.62a8264a3c585df0b20ca74bc27afcb9.svg";
export { ForwardRef as ReactComponent };